import React, { useEffect, useRef, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { FileUpload } from "primereact/fileupload";
import { Toast } from "primereact/toast";
import configurationManagementService from "@services/configuationManagement.service";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { BlockUI } from "primereact/blockui";
import { OverlayPanel } from "primereact/overlaypanel";
import { Calendar } from "primereact/calendar";
import { SelectButton } from "primereact/selectbutton";
import { InputText } from "primereact/inputtext";
import { error } from "highcharts";
import { Card } from "primereact/card";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { SplitButton } from "primereact/splitbutton";
import { Toolbar } from "primereact/toolbar";
import strftime from "strftime";
import { Tag } from "primereact/tag";
import jwt_decode from "jwt-decode";
import { Chip } from "primereact/chip";
import { Checkbox } from "primereact/checkbox";
import { MultiSelect } from "primereact/multiselect";
import { Message } from "primereact/message";

export default function Tracker2() {
  const toast = useRef(null);

  const [token, setToken] = useState(
    jwt_decode(localStorage.getItem("plano-jwt"))
  );
  const [blocked, setBlocked] = useState(false);
  const [file, setFile] = useState();
  const [attach, setAttach] = useState([]);
  const fileUploader = useRef(null);
  const fileUploaderAttachment = useRef(null);
  const [update, setUpdate] = useState(true);
  const [loading, setLoading] = useState(false);
  const [crNumber, setCrNumber] = useState();
  const [lastState, setLastState] = useState();
  const [forceUpdateChecked, setForceUpdateChecked] = useState(false);
  const [forceUpdateDisable, setForceUpdateDisable] = useState(true);
  const [dates, setDates] = useState(null);

  // const [summery, setSummery] = useState({
  //   Action: [],
  //   Done: { data: [], total: 0 },
  //   Fail: [],
  //   List: [],
  //   All: [],
  //   total: 0,
  // });
  const [data, setData] = useState([]);
  const [dataِDetails, setDataDetails] = useState([]);
  const [all, setAll] = useState({
    data: [],
    total: 0,
  });
  const [ID, setID] = useState();
  const [deadline, setDeadline] = useState();
  const [comment, setComment] = useState();
  const [commentUpdate, setCommentUpdate] = useState();
  const [priority, setPriority] = useState();
  const [reportsList, setReportsList] = useState([]);
  const [histories, setHistories] = useState();
  const [userName, setUserName] = useState("");
  const [files, setFiles] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [realActiveIndex, setRealActiveIndex] = useState(0);
  // cmUser
  const [cmUser, setCmUser] = useState([]);

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    "CR NUMBER": { value: null, matchMode: FilterMatchMode.CONTAINS },
    Requester: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Site: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Cell: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Region: { value: null, matchMode: FilterMatchMode.IN },
    Tech: { value: null, matchMode: FilterMatchMode.IN },
    "BSC/RNC/LTE ZONE": { value: null, matchMode: FilterMatchMode.CONTAINS },
    lastStatus: { value: null, matchMode: FilterMatchMode.EQUALS },
    statuses: { value: null, matchMode: FilterMatchMode.IN },
    "Mail Subject": { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [filtersDetails, setFiltersDetails] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    "CR NUMBER": { value: null, matchMode: FilterMatchMode.CONTAINS },
    Requester: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Site: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Cell: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Region: { value: null, matchMode: FilterMatchMode.IN },
    Tech: { value: null, matchMode: FilterMatchMode.IN },
    "BSC/RNC/LTE ZONE": { value: null, matchMode: FilterMatchMode.CONTAINS },
    lastStatus: { value: null, matchMode: FilterMatchMode.EQUALS },
    statuses: { value: null, matchMode: FilterMatchMode.IN },
    "Mail Subject": { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 25,
    page: 0,
    filters: filters,
    tabindex: activeIndex
  });
  useEffect(() => {
    console.log("fetchData");
    fetchData(lazyState, realActiveIndex);
  }, [update]);
  useEffect(() => {
    configurationManagementService
      .Get("/irancell/tracker2/cmUser")
      .then((result) => {
        setCmUser(result.data);
      })
      .catch((error) => {
        console.log(error);
      });
    const id = setInterval(fetchData(lazyState, realActiveIndex), 60000);
    return () => clearInterval(id);
  }, []);



  const fetchData = (lazyStatex, activeIndex) => {
    setUserName(
      token["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"]
    );
    setLoading(true);
    console.log("realActiveIndex", realActiveIndex);
    console.log("activeIndex", activeIndex);
    configurationManagementService
      .Post("/irancell/tracker2/getList2", { LazyState: lazyStatex })
      .then((result) => {
        if (activeIndex == 3) {
          setTotalRecords(result.data.total);
          setDataDetails(result.data.data);
        }
        else if (activeIndex < 3) {
          setTotalRecords(result.data.totalCount ? result.data.totalCount.length > 0 ? result.data.totalCount[0].count : 0 : 0);
          setData(result.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
        toast.current.show({ severity: 'error', summary: 'error', detail: error.message });
      }).finally(() => {
        setLoading(false);
      });
  };
  const onDeleteReport = (row) => {
    configurationManagementService
      .Post("/irancell/tracker2/delete", { crnumber: row.crnumber })
      .then((response) => {
        toast.current.show({
          severity: "info",
          summary: "Info",
          detail: "Success",
        });
        setUpdate(!update);
      })
      .catch((err) => {
        console.log(err);
        toast.current.show({
          severity: "error",
          summary: "error",
          detail: err.message,
        });
      });
  };
  const onDownload = (row) => {
    setBlocked(true);
    configurationManagementService
      .PostBlob("/irancell/tracker2/download", { id: row._id })
      .then((response) => {
        const href = URL.createObjectURL(new Blob([response.data]));

        // create "a" HTML element with href to file & click
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", row.crnumber + ".xlsx"); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
        setBlocked(false);
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: "error",
          detail: "Download Fails",
        });
        setBlocked(false);
      });
  };

  const dateBodyTemplate = (row, column) => {
    let columnName = column.column.props.header;

    return new Date(row[columnName]).toLocaleString();
  };
  const op = useRef(null);
  const op2 = useRef(null);
  const fileVisible = useRef(null);
  const Save = () => {
    if (commentUpdate) {
      const formData = new FormData();
      // console.log("attach", attach);
      if (attach) {
        for (let [index, val] of attach.entries()) {
          formData.append("crAttach" + index, val);
        }
      }

      formData.append("records", JSON.stringify(selectetCR));
      formData.append("lastStatus", lastState);
      formData.append("comment", commentUpdate);
      formData.append("activeIndex", activeIndex);
      // console.log("selectetCR", selectetCR);
      // { records: selectetCR.map(p => p._id), updateQuery: { lastStatus: lastState }, comment: commentUpdate, }
      setBlocked(true);
      if (lastState === "Delete") {
        configurationManagementService
          .PostForm("/irancell/tracker2/delete", formData)
          .then((response) => {
            // console.log("delete", response);
            toast.current.show({
              severity: "info",
              summary: "Info",
              detail: "Success",
            });
            setUpdate(!update);
            setCommentUpdate("");
            op.current.hide();
            setBlocked(false);
            let _filters = { ...filters };
            onFilter({ filters: _filters });
          })
          .catch((err) => {
            toast.current.show({
              severity: "error",
              summary: "error",
              detail: "You do not have permission",
            });
            setBlocked(false);
          });
      } else {
        configurationManagementService
          .PostForm("/irancell/tracker2/update", formData)
          .then((response) => {
            toast.current.show({
              severity: "info",
              summary: "Info",
              detail: "Success",
            });
            setUpdate(!update);
            setBlocked(false);
            setCommentUpdate("");
            let _filters = { ...filters };
            onFilter({ filters: _filters });
            op.current.hide();
          })
          .catch((err) => {
            console.log(err);
            toast.current.show({
              severity: "error",
              summary: "error",
              detail: "You do not have permission",
            });
            setBlocked(false);
          });
      }
    } else {
      toast.current.show({
        severity: "error",
        summary: "error",
        detail: "Comment is mandatory",
      });
    }
  };
  const upload = () => {
    const formData = new FormData();
    formData.append("crFile", file);
    for (let [index, val] of attach.entries()) {
      formData.append("crAttach" + index, val);
    }
    formData.append("crnumber", crNumber);
    formData.append("deadline", deadline);
    formData.append("comment", comment);
    formData.append("priority", priority);
    formData.append("activeIndex", activeIndex);
    formData.append("forceUpdate", forceUpdateChecked);

    setBlocked(true);
    configurationManagementService
      .PostForm("/irancell/tracker2/Add", formData)
      .then((result) => {
        if (result.data.errors.length === 0) {
          toast.current.show({
            severity: "info",
            summary: "Info",
            detail: "Success",
          });
          fileUploader.current.clear();
          setForceUpdateChecked(false);
          setForceUpdateDisable(true);
          setUpdate(!update);
        } else {
          for (const error of result.data.errors) {
            toast.current.show({
              severity: "error",
              summary: "error",
              detail: JSON.stringify(error),
            });
            if (error === "CR number exsist.Choose force update.") {
              setForceUpdateDisable(false);
            }
          }
        }
        setBlocked(false);
      })
      .catch((error) => {
        toast.current.show({
          severity: "error",
          summary: "error",
          detail: "unknown error",
        });
        setBlocked(false);
      });
  };
  // ['CR NUMBER', 'Requester', 'Site', 'Cell', 'Region']

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  const renderHeader = () => {
    return "";
  };
  const header = renderHeader();
  const items2 = [
    {
      label: "Update",
      icon: "pi pi-refresh",
    },
    {
      label: "Delete",
      icon: "pi pi-times",
    },
    {
      label: "React Website",
      icon: "pi pi-external-link",
      command: () => {
        window.location.href = "https://reactjs.org/";
      },
    },
    {
      label: "Upload",
      icon: "pi pi-upload",
      command: () => {
        //router.push('/fileupload');
      },
    },
  ];
  const [selectetCR, setSelectedCR] = useState();
  const [atollDates, setAtollDates] = useState();
  useEffect(() => {
    configurationManagementService
      .Get("/irancell/tracker2/atoll/dates")
      .then((result) => {
        setAtollDates(result.data);
      });
  }, []);
  const atollClick = (e) => {
    configurationManagementService
      .Post("/irancell/tracker2/atoll", { date: e.value })
      .then((result) => {
        import("xlsx").then((xlsx) => {
          // setBlocked(true);
          const workbook = xlsx.utils.book_new();
          const worksheet = xlsx.utils.json_to_sheet(result.data);
          xlsx.utils.book_append_sheet(workbook, worksheet, "CR");
          const excelBuffer = xlsx.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });

          saveAsExcelFile(excelBuffer, "CR-", ".xlsx");
        });
      });
  };
  const onClick = (e, state) => {
    if (selectetCR) {
      setLastState(state);
      setAttach([]);
      op.current.toggle(e);
    } else {
      toast.current.show({
        severity: "warn",
        summary: "Update",
        detail: "Select a CR",
      });
    }
  };
  const items_export = [
    {
      label: "Summery",
      icon: "pi pi-arrow-circle-down",
      command: () => {
        exportCsv("Summery");
      },
    },
    {
      label: "Details",
      icon: "pi pi-arrow-circle-down",
      command: () => {
        exportCsv("Details");
      },
    },
    {
      label: "Selected CR Details",
      icon: "pi pi-arrow-circle-down",
      command: () => {
        exportCsv("Selected");
      },
    },
  ];
  const startContent = () => {
    // let userName = token["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"]
    if (cmUser.indexOf(userName) > -1) {
      return (
        <React.Fragment>
          {/* <InputText
            value={globalFilterValue}
            className="mr-2"
            onChange={onGlobalFilterChange}
            placeholder="Keyword Search"
          /> */}
          <Button
            label="Implementing"
            onClick={(e) => onClick(e, "Implementing")}
            icon="pi pi-wrench"
            className="p-button-secondary mr-4"
          />
          <Button
            label="Done"
            onClick={(e) => onClick(e, "Done")}
            icon="pi pi-thumbs-up "
            className="p-button-success mr-4"
          />
          <Button
            label="Fail"
            onClick={(e) => onClick(e, "Fail")}
            icon="pi pi-times"
            className="p-button-help mr-4"
          />
          <Button
            label="Reject"
            onClick={(e) => onClick(e, "Reject")}
            icon="pi pi-thumbs-down"
            className="p-button-danger mr-4"
          />
          <Button
            label="Delete"
            onClick={(e) => onClick(e, "Delete")}
            icon="pi pi-times"
            className="p-button-help mr-4"
          />
          <Button
            label="Check Done"
            onClick={(e) => onClick(e, "CheckDone")}
            icon="pi pi-eye-slash"
            severity="warning"
            className="p-button-secondary mr-4"
          />
          <Calendar
            placeholder="Select date for export"
            value={dates}
            onChange={(e) => setDates(e.value)}
            selectionMode="range"
            readOnlyInput
          />
          <SplitButton
            label="Export"
            className=""
            icon="pi pi-arrow-circle-down"
            onClick={(e) => {
              toast.current.show({
                severity: "warn",
                summary: "Export",
                detail: "Select a type to export",
              });
            }}
            model={items_export}
          />
        </React.Fragment>
      );
    } else if (userName === "testuser@test.com") {
      // console.log(userName);
      return (
        <React.Fragment>
          {/* <InputText
            value={globalFilterValue}
            className="mr-2"
            onChange={onGlobalFilterChange}
            placeholder="Keyword Search"
          /> */}
          <Button
            label="Implementing"
            onClick={(e) => onClick(e, "Implementing")}
            icon="pi pi-wrench"
            className="p-button-secondary mr-4"
          />
          <Button
            label="Done"
            onClick={(e) => onClick(e, "Done")}
            icon="pi pi-thumbs-up "
            className="p-button-success mr-4"
          />
          <Button
            label="Fail"
            onClick={(e) => onClick(e, "Fail")}
            icon="pi pi-times"
            className="p-button-help mr-4"
          />
          <Button
            label="Reject"
            onClick={(e) => onClick(e, "Reject")}
            icon="pi pi-thumbs-down"
            className="p-button-danger mr-4"
          />
          <Button
            label="Delete"
            onClick={(e) => onClick(e, "Delete")}
            icon="pi pi-times"
            className="p-button-help mr-4"
          />
          {/* <Button
            label="Renew"
            onClick={(e) => onClick(e, "New")}
            icon="pi pi-refresh"
            className="p-button-secondary mr-4"
          /> */}
          <Button
            label="Attach"
            onClick={(e) => onClick(e, "New")}
            icon="pi pi-upload"
            className="p-button-secondary mr-4"
          />
          <Button
            label="Urgent"
            onClick={(e) => onClick(e, "Urgent")}
            icon="pi pi-clock"
            className="p-button-secondary mr-4"
          />
          <Button
            label="Normal"
            onClick={(e) => onClick(e, "Normal")}
            icon="pi pi-clock"
            className="p-button-secondary mr-4"
          />
          <Button
            label="Rollback"
            onClick={(e) => onClick(e, "Rollback")}
            icon="pi pi-sync"
            severity="Danger"
            className="p-button-secondary mr-4"
          />
          <Button
            label="Check"
            onClick={(e) => onClick(e, "Check")}
            icon="pi pi-eye"
            severity="warning"
            className="p-button-secondary mr-4"
          />
          <Button
            label="Check Done"
            onClick={(e) => onClick(e, "CheckDone")}
            icon="pi pi-eye-slash"
            severity="warning"
            className="p-button-secondary mr-4"
          />
          <Calendar
            placeholder="Select date for export"
            value={dates}
            onChange={(e) => setDates(e.value)}
            selectionMode="range"
            readOnlyInput
          />
          <SplitButton
            label="Export"
            className=""
            icon="pi pi-arrow-circle-down"
            onClick={(e) => {
              toast.current.show({
                severity: "warn",
                summary: "Export",
                detail: "Select a type to export",
              });
            }}
            model={items_export}
          />
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <InputText
            value={globalFilterValue}
            className="mr-2"
            onChange={onGlobalFilterChange}
            placeholder="Keyword Search"
          />
          {/* <Button
            label="Renew"
            onClick={(e) => onClick(e, "New")}
            icon="pi pi-refresh"
            className="p-button-secondary mr-4"
          /> */}
          <Button
            label="Attach"
            onClick={(e) => onClick(e, "New")}
            icon="pi pi-upload"
            className="p-button-secondary mr-4"
          />
          <Button
            label="Urgent"
            onClick={(e) => onClick(e, "Urgent")}
            icon="pi pi-clock"
            className="p-button-secondary mr-4"
          />
          <Button
            label="Normal"
            onClick={(e) => onClick(e, "Normal")}
            icon="pi pi-clock"
            className="p-button-secondary mr-4"
          />
          <Button
            label="Rollback"
            onClick={(e) => onClick(e, "Rollback")}
            icon="pi pi-sync"
            severity="Danger"
            className="p-button-secondary mr-4"
          />
          <Button
            label="Check"
            onClick={(e) => onClick(e, "Check")}
            icon="pi pi-eye"
            severity="warning"
            className="p-button-secondary mr-4"
          />

          <Button
            label="Exports"
            icon="pi pi-download"
            onClick={(e) => exportCsv()}
            className="p-button-Primary mr-4"
          />
          <Button
            label="Delete"
            onClick={(e) => onClick(e, "Delete")}
            icon="pi pi-times"
            className="p-button-help mr-4"
          />
          <Calendar
            placeholder="Select date for export"
            value={dates}
            onChange={(e) => setDates(e.value)}
            selectionMode="range"
            readOnlyInput
          />
          <SplitButton
            label="Export"
            className=""
            icon="pi pi-arrow-circle-down"
            onClick={(e) => {
              toast.current.show({
                severity: "warn",
                summary: "Export",
                detail: "Select a type to export",
              });
            }}
            model={items_export}
          />
        </React.Fragment>
      );
    }
  };
  const exportCsv = async (export_type) => {
    var rows = [];

    setBlocked(true);
    switch (export_type) {
      case "Selected":
        if (selectetCR && selectetCR["CR NUMBER"]) {
          let filter = {
            filters: {
              "CR NUMBER": {
                value: selectetCR["CR NUMBER"],
                matchMode: "contains",
              },
            },
          };
          rows = (
            await configurationManagementService.Post(
              "/irancell/tracker2/getList2_filter",
              filter
            )
          ).data.data;
        } else {
          toast.current.show({
            severity: "warn",
            summary: "Update",
            detail: "Select a CR",
          });
          setBlocked(false);
          return 0;
        }

        break;
      case "Summery":
        try {
          rows = (
            await configurationManagementService.Post(
              "/irancell/tracker2/getList2",
              {
                LazyState: {
                  first: 0,
                  rows: 100000000,
                  page: 0,
                  filters: [],
                  tabindex: 5
                }
              }
            )
          ).data.data;
        } catch (error) {
          toast.current.show({
            severity: "warn",
            summary: "Update",
            detail: "Select a CR",
          });
        }

        break;
      case "Details":
        if (dates == null) {
          toast.current.show({
            severity: "warn",
            summary: "error",
            detail: "Select date for export",
          });
          setBlocked(false);
          return 0;
        }
        await configurationManagementService
          .PostBlob("/irancell/tracker2/getList2_date", { dates: dates }, null)
          .then((response) => {
            const href = URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = href;
            link.setAttribute(
              "download",
              `CM_Tracker-Export-Details-${new Date(
                Date.now()
              ).toLocaleDateString()}.zip`
            );
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          }).catch((err) => {
            toast.current.show({
              severity: "error",
              summary: "error",
              detail: err,
            });
          }

          );
        break;
      default:
        return 0;
    }
    setBlocked(false);
    for (const row of rows) {
      for (const key in row) {
        if (
          key.toLowerCase().includes("date") &&
          !key.toLowerCase().includes("atoll")
        ) {
          row[key] = new Date(row[key]).toLocaleDateString();
        }
      }
    }

    if (export_type !== "Details") {
      import("xlsx").then((xlsx) => {
        // setBlocked(true);
        const workbook = xlsx.utils.book_new();
        const worksheet = xlsx.utils.json_to_sheet(rows);
        xlsx.utils.book_append_sheet(workbook, worksheet, "CR");
        const excelBuffer = xlsx.write(workbook, {
          bookType: "csv",
          type: "array",
        });

        saveAsExcelFile(excelBuffer, "CR-", ".csv");
      });
    }
  };
  const onCellEditComplete = (e) => {
    let { rowData, newValue, field, originalEvent: event } = e;
    // console.log(rowData);
    // console.log(newValue, field);
    if (rowData[field] === newValue) {
      return 0;
    }
    setBlocked(true);

    configurationManagementService
      .Post("/irancell/tracker2/updateOne", {
        oldvalue: rowData[field],
        newvalue: newValue,
        field: field,
        row: rowData,
      })
      .then((response) => {
        toast.current.show({
          severity: "info",
          summary: "Info",
          detail: "Success",
        });
        setUpdate(!update);
        setBlocked(false);
        setCommentUpdate("");
        let _filters = { ...filters };
        onFilterDetails({ filters: _filters });
        op.current.hide();
      })
      .catch((err) => {
        console.log(err);
        toast.current.show({
          severity: "error",
          summary: "error",
          detail: "You do not have permission",
        });
        setBlocked(false);
      });
  };
  const saveAsExcelFile = (buffer, fileName, EXCEL_EXTENSION) => {
    import("file-saver").then(async (module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });
        await module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };
  const endContent = (
    <React.Fragment>
      <Button icon="pi pi-search" className="mr-2" />
      <Button icon="pi pi-calendar" className="p-button-success mr-2" />
      <Button icon="pi pi-times" className="p-button-danger" />
    </React.Fragment>
  );
  const textEditor = (options) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
      />
    );
  };
  const [statuses] = useState([
    "New",
    "Implementing",
    "Done",
    "Fail",
    "Reject",
    "Atoll",
  ]);
  const statusRowFilterTemplate = (options) => {
    return (
      <MultiSelect
        value={options.value}
        options={statuses}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder="Select One"
        className="p-column-filter"
        showClear
        style={{ minWidth: "12rem" }}
      />
    );
  };
  const [regions] = useState(["R1", "R2", "R3", "R4"]);
  const regionRowFilterTemplate = (options) => {
    return (
      <MultiSelect
        value={options.value}
        multiple
        options={regions}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder="Select One"
        className="p-column-filter"
        showClear
        style={{ minWidth: "12rem" }}
      />
    );
  };
  const [techs] = useState(["2G", "3G", "4G", "TDD", "5G"]);
  const techRowFilterTemplate = (options) => {
    return (
      <MultiSelect
        value={options.value}
        multiple
        options={techs}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder="Select One"
        className="p-column-filter"
        showClear
        style={{ minWidth: "12rem" }}
      />
    );
  };
  // const fllowTemplate = (rowData) => {
  //   return (

  //   );
  // };

  const downloadTemplate = (rowData) => {
    return (
      <div className="flex space-x-1">
        <Button
          icon="pi pi-history"
          onClick={(e) => {
            setID(rowData._id);
            op2.current.toggle(e);
          }}
          severity="secondary"
          size="small"
        />
        <Button
          icon="pi pi-file-word"
          onClick={(e) => {
            setCrNumber(rowData["CR NUMBER"]);
            // console.log(data.filter((q) => q._id === crNumber));
            // console.log(crNumber);
            fileVisible.current.toggle(e);
          }}
          severity="secondary"
          size="small"
        />
        <Button
          icon="pi pi-arrow-up-right"
          onClick={(e) => {
            // setCrNumber(rowData["CR NUMBER"]);
            setSelectedCR(null);
            setRealActiveIndex(3);
            setActiveIndex(3);

            setLastState()
            let _filters = { ...filtersDetails };
            _filters["CR NUMBER"].value = rowData["CR NUMBER"];
            setFiltersDetails(_filters);
            setUpdate(!update);
            onFilterDetails({ filters: _filters }, 3);
          }}
          severity="secondary"
          size="small"
        />
      </div>
    );
  };
  // const linkTemplate = (rowData) => {
  //   return (

  //   );
  // };
  // const clearFilter = () => {
  //   let _filters = { ...filters };
  //   _filters["CR NUMBER"].value = "";
  //   setFilters(_filters);
  // };
  // const clearFilterDetails = () => {
  //   let _filters = { ...filtersDetails };
  //   _filters["CR NUMBER"].value = "";
  //   setFiltersDetails(_filters);
  // };
  const UrgentTemplate = (rowData) => {
    // if (rowData.Urgent) {
    //   return <Tag severity="danger" value="Urgent"></Tag>;
    // } else if (rowData.updated) {
    //   return <Tag severity="warning" value="Update"></Tag>;
    // } else if (rowData.rollback) {
    //   return <Tag severity="warning" value="Rollback"></Tag>;
    // } else if (rowData.check) {
    //   return <Tag severity="warning" value="Check"></Tag>;
    // } else {
    //   return "";
    // }
    return (
      <>
        {rowData.Urgent ? <Tag severity="danger" value="Urgent"></Tag> : ""}
        {rowData.updated ? <Tag severity="warning" value="Update"></Tag> : ""}
        {rowData.rollback ? (
          <Tag severity="warning" value="Rollback"></Tag>
        ) : (
          ""
        )}
        {rowData.check ? <Tag severity="warning" value="Check"></Tag> : ""}
      </>
    );
  };
  const downloadActionTemplate = (row) => {
    return (
      <Button
        icon="pi pi-cloud-download"
        onClick={(e) => {
          configurationManagementService
            .PostBlob("/irancell/tracker2/files/download", { fileID: row._id })
            .then((response) => {
              const href = URL.createObjectURL(new Blob([response.data]));

              // create "a" HTML element with href to file & click
              const link = document.createElement("a");
              link.href = href;
              link.setAttribute("download", row.filename); //or any other extension
              document.body.appendChild(link);
              link.click();

              // clean up "a" element & remove ObjectURL
              document.body.removeChild(link);
              URL.revokeObjectURL(href);
              setBlocked(false);
            })
            .catch((err) => {
              toast.current.show({
                severity: "error",
                summary: "error",
                detail: "Download Fails",
              });
              setBlocked(false);
            });
        }}
        size="small"
      />
    );
  };
  const deleteActionTemplate = (row) => {
    return (
      <Button
        icon="pi pi-times"
        onClick={(e) => {
          configurationManagementService
            .PostBlob("/irancell/tracker2/files/delete", { fileID: row._id })
            .then((response) => {
              toast.current.show({
                severity: "info",
                summary: "info",
                detail: "Remove Done",
              });
              let newFileList = files.filter((p) => p._id !== row._id);
              setFiles(newFileList);
              setBlocked(false);
            })
            .catch((err) => {
              toast.current.show({
                severity: "error",
                summary: "error",
                detail: "Remove Fails",
              });
              setBlocked(false);
            });
        }}
        size="small"
      />
    );
  };
  const rowClassName = (rowData) => {
    if (rowData.updated === true) {
      // console.log(rowData);
      return "bg-yellow-200";

      // return 'red-row';
    }

    return "";
  };
  const onFilter = (e, tabIndex) => {
    lazyState['first'] = 0;
    lazyState['tabindex'] = realActiveIndex;
    if (tabIndex) {
      lazyState['tabindex'] = tabIndex;
    }
    lazyState.filters = e.filters;
    setlazyState(lazyState);
    setFilters(e.filters);
    setUpdate(!update);

  };
  const onFilterDetails = (e, tabIndex) => {
    // console.log("e", e);
    // first: 0,
    //   rows: 25,
    //     page: 0,
    lazyState['first'] = 0;
    lazyState['rows'] = 50;
    lazyState['page'] = 0;
    setSelectedCR(null);
    lazyState['tabindex'] = realActiveIndex;
    if (tabIndex) {
      lazyState['tabindex'] = tabIndex;
    }
    lazyState.filters = e.filters;
    setlazyState(lazyState);
    setFiltersDetails(e.filters);
    setUpdate(!update);
  };

  const headerTemplate = (options) => {
    const { className, chooseButton, uploadButton, cancelButton } = options;
    return (
      <div
        className={className}
        style={{
          backgroundColor: "transparent",
          display: "flex",
          alignItems: "center",
        }}
      >
        {chooseButton}
        {cancelButton}
      </div>
    );
  };
  const onTabChange = (e) => {
    console.log(e)
    if (e.index < 3) {
      setActiveIndex(0);

    }
    else {
      setActiveIndex(e.index);
    }
    if (e.index == 3) {
      lazyState.filters = filtersDetails;
      // setFiltersDetails({
      //   global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      //   "CR NUMBER": { value: null, matchMode: FilterMatchMode.CONTAINS },
      //   Requester: { value: null, matchMode: FilterMatchMode.CONTAINS },
      //   Site: { value: null, matchMode: FilterMatchMode.CONTAINS },
      //   Cell: { value: null, matchMode: FilterMatchMode.CONTAINS },
      //   Region: { value: null, matchMode: FilterMatchMode.IN },
      //   Tech: { value: null, matchMode: FilterMatchMode.IN },
      //   "BSC/RNC/LTE ZONE": { value: null, matchMode: FilterMatchMode.CONTAINS },
      //   lastStatus: { value: null, matchMode: FilterMatchMode.EQUALS },
      //   statuses: { value: null, matchMode: FilterMatchMode.IN },
      //   "Mail Subject": { value: null, matchMode: FilterMatchMode.CONTAINS },
      // });
      // setFilters({
      //   global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      //   "CR NUMBER": { value: null, matchMode: FilterMatchMode.CONTAINS },
      //   Requester: { value: null, matchMode: FilterMatchMode.CONTAINS },
      //   Site: { value: null, matchMode: FilterMatchMode.CONTAINS },
      //   Cell: { value: null, matchMode: FilterMatchMode.CONTAINS },
      //   Region: { value: null, matchMode: FilterMatchMode.IN },
      //   Tech: { value: null, matchMode: FilterMatchMode.IN },
      //   "BSC/RNC/LTE ZONE": { value: null, matchMode: FilterMatchMode.CONTAINS },
      //   lastStatus: { value: null, matchMode: FilterMatchMode.EQUALS },
      //   statuses: { value: null, matchMode: FilterMatchMode.IN },
      //   "Mail Subject": { value: null, matchMode: FilterMatchMode.CONTAINS },
      // });
    }
    else {
      lazyState.filters = filters;
    }
    setRealActiveIndex(e.index);
    lazyState.tabindex = e.index;
    lazyState.page = 0;
    lazyState.rows = 25;
    setlazyState(lazyState);
    // setUpdate(!update);
    // console.log("tab changed", lazyState);
    fetchData(lazyState, e.index);
    setSelectedCR([]);
    // console.log("tab changed");

  };
  const [totalRecords, setTotalRecords] = useState(0);


  const OnPage = (e) => {
    console.log(e);
    lazyState.page = e.page;
    lazyState.first = e.first;
    lazyState.rows = e.rows;
    lazyState.tabindex = realActiveIndex;
    setlazyState(lazyState);
    setUpdate(!update);
  };

  return (
    <div className="card">
      <BlockUI blocked={blocked}>
        <Toolbar start={startContent} />
        <TabView
          activeIndex={activeIndex}
          onTabChange={onTabChange}
          className="m-4"
        >
          <TabPanel
            leftIcon="pi pi-gift mr-2"
            className="mr-2 ml-2"
            header={"New"}
          >
            <DataTable
              dataKey="CR NUMBER"
              filters={filters}
              lazy
              onFilter={onFilter}
              paginator
              rows={lazyState.rows}
              onPage={OnPage}
              first={lazyState.first}
              totalRecords={totalRecords}
              selection={selectetCR}
              onSelectionChange={(e) => setSelectedCR(e.value)}
              filterDisplay="row"
              loading={loading}
              selectionMode="single"
              rowClassName={rowClassName}
              globalFilterFields={["CR NUMBER", "Requester"]}
              value={data}
            >
              <Column body={downloadTemplate}></Column>
              {/* <Column style={{ width: '12px' }} body={fllowTemplate}  ></Column>
              <Column style={{ width: '12px' }} body={linkTemplate}   ></Column> */}
              <Column body={UrgentTemplate} header="State"></Column>
              <Column
                sortable
                field="Request Date"
                body={dateBodyTemplate}
                showFilterMenu={false}
                filter
                header="Request Date"
              ></Column>
              <Column
                showFilterMenu={false}
                filter
                filterField="CR NUMBER"
                field="CR NUMBER"
                // onFilterClear={clearFilter}
                header="CR NUMBER"
              ></Column>
              <Column
                showFilterMenu={false}
                filter
                filterField="Requester"
                field="Requester"
                header="Requester"
              ></Column>
              <Column
                showFilterMenu={false}
                filter
                filterField="statuses"
                field="statuses"
                header="statuses"
              ></Column>
              <Column
                showFilterMenu={false}
                filter
                body={(rowData) => (
                  <div>
                    {rowData["Mail Subject"].replaceAll(/[^a-zA-Z0-9 ]/g, " ")}
                  </div>
                )}
                filterField="Mail Subject"
                field="Mail Subject"
                header="Mail Subject"
              ></Column>
              <Column
                showFilterMenu={false}
                filter
                filterElement={regionRowFilterTemplate}
                filterField="Region"
                field="Region"
                header="Region"
              ></Column>
              <Column
                showFilterMenu={false}
                filter
                filterElement={techRowFilterTemplate}
                filterField="Tech"
                field="Tech"
                header="Tech"
              ></Column>
            </DataTable>
          </TabPanel>
          <TabPanel
            leftIcon="pi pi-gift mr-2"
            className="mr-2 ml-2"
            header={"Done"}
          >

          </TabPanel>
          <TabPanel
            leftIcon="pi pi-gift mr-2"
            className="mr-2 ml-2"
            header={"Fail"}
          >

          </TabPanel>
          <TabPanel
            leftIcon="pi pi-gift mr-2"
            className="mr-2 ml-2"
            header={"Details"}
          >
            <DataTable
              dataKey="_id"
              // paginator
              // rows={20}
              filters={filtersDetails}
              lazy
              onFilter={onFilterDetails}
              paginator
              rows={lazyState.rows}
              onPage={OnPage}
              first={lazyState.first}
              totalRecords={totalRecords}
              loading={loading}
              // onPage={onFilter}
              selection={selectetCR}
              onSelectionChange={(e) => setSelectedCR(e.value)}
              filterDisplay="row"
              editMode="cell"
              rowsPerPageOptions={[50, 100, 500, 5000]}
              // totalRecords={100}
              rowClassName={rowClassName}
              // onPageChange={onFilter}
              globalFilterFields={[
                "CR NUMBER",
                "Requester",
                "Site",
                "Cell",
                "Region",
                "lastStatus",
              ]}
              value={dataِDetails}
            >
              <Column
                selectionMode="multiple"
                headerStyle={{ width: "3rem" }}
              />
              <Column
                body={UrgentTemplate}
                style={{ width: "50px" }}
                header="Status"
              ></Column>
              <Column
                style={{ width: "50px" }}
                field="lastStatus"
                filterField="lastStatus"
                showFilterMenu={false}
                filter
                filterElement={statusRowFilterTemplate}
                header="state"
              ></Column>
              <Column
                field="lastUpdate"
                style={{ width: "150px" }}
                body={dateBodyTemplate}
                header="lastUpdate"
              ></Column>
              <Column
                style={{ width: "200px" }}
                showFilterMenu={false}
                filter
                filterField="CR NUMBER"
                // onFilterClear={clearFilter}
                field="CR NUMBER"
                header="CR NUMBER"
              ></Column>
              <Column
                style={{ width: "200px" }}
                showFilterMenu={false}
                filter
                filterField="Requester"
                field="Requester"
                header="Requester"
              ></Column>
              {/* <Column showFilterMenu={false} filter filterField="Requester" field="Requester" header="Requester"></Column> */}
              {/* <Column showFilterMenu={false} filter filterField="Request Date" field="Request Date" header="Request Date"></Column> */}
              {/* <Column body={dateBodyTemplate} header="Last Update"></Column> */}
              {/* <Column style={{ width: '50px' }} showFilterMenu={false} filter filterElement={regionRowFilterTemplate} field="Region" header="Region"></Column> */}
              {/* <Column showFilterMenu={false} filter filterField="Tech" field="Tech" header="Tech"></Column> */}
              <Column
                style={{ width: "145px" }}
                showFilterMenu={false}
                filter
                filterField="BSC/RNC/LTE ZONE"
                field="BSC/RNC/LTE ZONE"
                header="BSC/RNC/LTE ZONE"
              ></Column>
              <Column
                style={{ width: "100px" }}
                showFilterMenu={false}
                filter
                filterField="Site"
                field="Site"
                header="Site"
              ></Column>
              <Column
                style={{ width: "140px" }}
                showFilterMenu={false}
                filter
                filterField="Cell"
                field="Cell"
                header="Cell"
              ></Column>
              <Column field="Parameter Name" header="P Name"></Column>
              <Column
                field="Parameter Pre-Value"
                editor={(options) => textEditor(options)}
                onCellEditComplete={onCellEditComplete}
                header="pre"
              ></Column>
              <Column
                field="Parameter post-Value"
                editor={(options) => textEditor(options)}
                onCellEditComplete={onCellEditComplete}
                header="post"
              ></Column>
              <Column
                showFilterMenu={false}
                filter
                body={(rowData) => (
                  <div>
                    {rowData["Mail Subject"]
                      ? rowData["Mail Subject"].replaceAll(
                        /[^a-zA-Z0-9 ]/g,
                        " "
                      )
                      : ""}
                  </div>
                )}
                filterField="Mail Subject"
                field="Mail Subject"
                header="Mail Subject"
              ></Column>

              {/* <Column body={fllowTemplate}  ></Column>
              <Column body={downloadTemplate}   ></Column> */}

              {/* <Column field="Remark" header="Remark"></Column> */}
              {/* <Column showFilterMenu={false} filter filterField="Implementor" field="Implementor" header="Implementor"></Column> */}
              {/* <Column showFilterMenu={false} filter filterField="Atoll" field="Atoll" header="Atoll"></Column> */}
            </DataTable>
          </TabPanel>
          <TabPanel
            leftIcon="pi pi-cloud-upload mr-2"
            className="mr-2 ml-2"
            header="New CR"
          >
            <Card title="Tracker Import">
              <div className="sm:col-span-4">
                <label
                  htmlFor="username"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  CR File
                </label>
                <div className="m-2">
                  <FileUpload
                    mode="basic"
                    ref={fileUploader}
                    name="main"
                    onValidationFail={(e) =>
                      toast.current.show({
                        severity: "error",
                        summary: "error",
                        detail: "MAX Filesize is 5 MB",
                      })
                    }
                    onClear={(e) => setFile(null)}
                    onSelect={(e) => setFile(e.files[0])}
                    maxFileSize={5000000}
                    emptyTemplate={
                      <p className="m-0">
                        Drag and drop files to here to upload.
                      </p>
                    }
                  />
                </div>
              </div>
              <div className="sm:col-span-4">
                <label
                  htmlFor="username"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Attachments :
                </label>
                <Message
                  severity="warn"
                  text="اگر فایلی غیر از فایل اصلی برای اجرا نیاز است اینجا اضافه کنید"
                />
                <div className="m-2">
                  <FileUpload
                    headerTemplate={headerTemplate}
                    multiple={true}
                    ref={fileUploader}
                    name="attachments"
                    onValidationFail={(e) =>
                      toast.current.show({
                        severity: "error",
                        summary: "error",
                        detail: "MAX Filesize is 5 MB",
                      })
                    }
                    onClear={(e) => setAttach([])}
                    onSelect={(e) => setAttach(e.files)}
                    maxFileSize={5000000}
                    emptyTemplate={
                      <p className="m-0">
                        Drag and drop files to here to upload.
                      </p>
                    }
                  />
                </div>
              </div>
              <div className="sm:col-span-4 ">
                <Checkbox
                  inputId="ingredient1"
                  name="pizza"
                  disabled={forceUpdateDisable}
                  value="Cheese"
                  onChange={(e) => setForceUpdateChecked(e.checked)}
                  checked={forceUpdateChecked}
                />
                <label htmlFor="ingredient1" className="ml-2">
                  Force Update
                </label>
              </div>
              <div className="sm:col-span-4">
                <label
                  htmlFor="username"
                  className="block text-sm font-medium leading-6 text-gray-900"
                ></label>
                <div className="mt-2">
                  <Button label="Upload" onClick={(e) => upload()} raised />
                </div>
              </div>
            </Card>
          </TabPanel>
          {/* <TabPanel leftIcon="pi pi-cloud-upload mr-2" className="mr-2 ml-2" header="New CR RET">
            <Card title="Tracker Import CR RET">
              <div className="sm:col-span-4">
                <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900">
                  CR File
                </label>
                <div className="m-2">
                  <FileUpload mode="basic" ref={fileUploader} name="main" onValidationFail={(e) => toast.current.show({ severity: 'error', summary: 'error', detail: 'MAX Filesize is 5 MB' })} onClear={(e) => setFile(null)} onSelect={(e) => setFile(e.files[0])} maxFileSize={5000000} emptyTemplate={<p className="m-0">Drag and drop files to here to upload.</p>} />
                </div>
              </div>
              <div className="sm:col-span-4">
                <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900">
                  Attachments :
                </label>
                <div className="m-2">
                  <FileUpload headerTemplate={headerTemplate} multiple={true} ref={fileUploader} name="attachments" onValidationFail={(e) => toast.current.show({ severity: 'error', summary: 'error', detail: 'MAX Filesize is 5 MB' })} onClear={(e) => setAttach([])} onSelect={(e) => setAttach(e.files)} maxFileSize={5000000} emptyTemplate={<p className="m-0">Drag and drop files to here to upload.</p>} />
                </div>
              </div>
              <div className="sm:col-span-4">
                <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900">
                </label>
                <div className="mt-2">
                  <Button label="Upload" onClick={(e) => upload()} raised />
                </div>
              </div>


            </Card>
          </TabPanel> */}
        </TabView>
      </BlockUI>
      <OverlayPanel ref={op}>
        <div className="space-y-12">
          <div className="pb-12">
            <div className="col-span-full">
              <label
                htmlFor="about"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Comment
              </label>
              <div className="mt-2">
                <textarea
                  value={commentUpdate}
                  onChange={(e) => setCommentUpdate(e.target.value)}
                  id="about"
                  name="about"
                  rows={3}
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  defaultValue={""}
                />
              </div>
              <p className="mt-3 text-sm leading-6 text-gray-600">
                Write a few sentences about CR.
              </p>
              <div className="mt-2">
                <FileUpload
                  multiple={true}
                  headerTemplate={headerTemplate}
                  ref={fileUploader}
                  name="demo[]"
                  onValidationFail={(e) =>
                    toast.current.show({
                      severity: "error",
                      summary: "error",
                      detail: "MAX Filesize is 5 MB",
                    })
                  }
                  onClear={(e) => setAttach([])}
                  onSelect={(e) => setAttach(e.files)}
                  maxFileSize={5000000}
                  emptyTemplate={
                    <p className="m-0">
                      Drag and drop files to here to upload.
                    </p>
                  }
                />
              </div>
            </div>
            <div className="sm:col-span-4">
              <label
                htmlFor="username"
                className="block text-sm font-medium leading-6 text-gray-900"
              ></label>
              <div className="mt-2">
                <Button label="Save" onClick={(e) => Save()} raised />
              </div>
            </div>
          </div>
        </div>
      </OverlayPanel>
      <OverlayPanel ref={op2}>
        <DataTable
          value={
            data.filter((q) => q._id === ID).length === 0
              ? []
              : data.filter((q) => q._id === ID)[0].logs
          }
        >
          <Column field="user" header="user"></Column>
          <Column field="comment" header="comment"></Column>
          <Column field="action" header="action"></Column>
          <Column body={dateBodyTemplate} header="date"></Column>
        </DataTable>
      </OverlayPanel>
      <OverlayPanel ref={fileVisible}>
        <DataTable
          className="p-datatable-sm"
          value={data.filter((q) => q._id === crNumber).length === 0 ? [] : data.filter((q) => q._id === crNumber)[0].files}
        >
          <Column field="user" header="user"></Column>
          <Column field="filename" header="filename"></Column>
          <Column field="action" header="action"></Column>
          <Column body={dateBodyTemplate} header="date"></Column>
          <Column body={downloadActionTemplate} header="download"></Column>
          <Column body={deleteActionTemplate} header="Delete"></Column>
        </DataTable>
      </OverlayPanel>
      <Toast ref={toast} />
    </div>
  );
}
